import React from "react";
import { H6, Image } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";
import { SuccessfullyCompleted } from "../../../../../../Constants/Constants";

const CompletedForm = () => {
  return (
    <div className="form-completed">
      <Image src={dynamicImage(`gif/dashboard-8/successful.gif`)} alt="successful" />
      <H6>{SuccessfullyCompleted}</H6>
    </div>
  );
};
export default CompletedForm;
